import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.839 13.72a.25.25 0 0 1-.25-.245c0-.289.709-2.186.88-3.462.02-.154-.17-.215-.257-.09-.413.598-.83 1.238-1.964 1.253-2.114.029-3.33-2.019-2.666-3.882C1.908 6.38 6.39.28 7 .28s5.092 6.1 5.418 7.014c.665 1.863-.553 3.91-2.666 3.882-1.134-.015-1.551-.655-1.965-1.253-.086-.125-.277-.064-.256.09.171 1.276.88 3.173.88 3.462a.25.25 0 0 1-.25.245z"
    }, null, -1)
  ])))
}
export default { render: render }